type Props = {
  title: string;
};

export function CatalogTitle({ title }: Props) {
  if (!title) return null;

  return (
    <h1 className="text-heading-5 lg:text-heading-4 font-bold text-gray-900">
      {title}
    </h1>
  );
}
